const translationPath = "settings.paymentSystems";

export default translationPath;
